export default __webpack_public_path__ + "static/media/logo-jawhara-mobile.22061383.svg";